import service from '@/utils/server';

const modName='/excellentCase/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

/**
 * 新增*提交
 * @param data
 * @returns {*}
 */
export const submitImport = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

/**
 * 编辑初始化
 * @param data
 * @returns {*}
 */
export const excellentCaseEditInit = data => {
  return service({
    url: modName + 'excellentCaseEditInit',
    method: 'post',
    data
  });
};

/**
 * 删除
 * @param data
 * @returns {*}
 */
export const cancelData = data => {
  return service({
    url: modName + 'cancel',
    method: 'post',
    data
  });
};

/**
 * 取消
 * @param data
 */
export const commentDelete = data =>{
  return service({
    url: modName + 'commentDelete',
    method: 'post',
    data
  });
}

/**
 * 首页推送
 * @param data
 * @returns {*}
 */
export const homePush = data =>{
  return service({
    url: modName + 'homePush',
    method: 'post',
    data
  });
}

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/case/bestPractices/api/index.js